import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Button from "@components/Button/button";
import styles from "./footerSection.module.scss";
import { renderWithBreaks } from '@utils/translations';

const CityButton = ({ countrySlug, countryName, locale }) => (
    <Button
      href={`/accommodation/${countrySlug}`}
      text={
        <FormattedMessage id="More about">
          {txt => (
            <p>
              {txt} {countryName}
            </p>
          )}
        </FormattedMessage>
      }
      locale={locale}
    />
  );

const FooterSection = ({ countryFooter, countrySlug, countryName, locale }) => {
  const intl = useIntl();

  if (!countryFooter) {
    return (
      <div className={styles.footerWithoutDescription}>
        <CityButton countrySlug={countrySlug} countryName={intl.formatMessage({ id: countryName })} locale={locale} />
      </div>
    );
  }

  return (
    <div className={styles.footer}>
      <div className={styles.footer__description}>
        {countryFooter && renderWithBreaks(intl.formatMessage({ id: `${countryName} footer` }))}
      </div>
      <CityButton countrySlug={countrySlug} countryName={intl.formatMessage({ id: countryName})} locale={locale} />
    </div>
  );
};

export default FooterSection;
